import React, { useState, useEffect } from "react";

import "./styles.scss";
import { IMaster } from "app/api/types";
import isEmail from "app/helpers/isEmail";

interface IProps {
  onSubmit: (data: IMaster) => void;
  onSuccessChange: (active: boolean) => void;
  isSubmit: boolean;
}

const AddMaster: React.FC<IProps> = ({
  onSubmit,
  onSuccessChange,
  isSubmit,
}) => {
  const [name, setName] = useState("");
  const [position, setPosition] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");

  const onChange = (e: any) => {
    e.target.name === "name" && setName(e.target.value);
    e.target.name === "position" && setPosition(e.target.value);
    e.target.name === "email" && setEmail(e.target.value);
    e.target.name === "description" && setDescription(e.target.value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    onSubmit({
      name,
      position,
      email,
      description,
      serviceIds: [],
      is_emploee: true,
    });
  };

  const getHeight = () => {
    let height = 50;
    if (name.length > 1) height += 47;
    if (position.length > 1) height += 47;
    if (email.length > 1) height += 47;
    if (description.length > 1) height += 20;

    return height;
  };

  useEffect(() => {
    if (
      name.length > 1 &&
      email.length > 1 &&
      position.length > 1 &&
      isEmail(email)
    )
      onSuccessChange(true);
    else onSuccessChange(false);

    isSubmit &&
      onSubmit({
        name,
        position,
        email,
        description,
        serviceIds: [],
        is_emploee: true,
      });
  }, [name, position, email, onSuccessChange, onSubmit, isSubmit, description]);

  const errorStyle = isEmail(email) ? "" : "add-phrase__input_error";

  return (
    <div className="add-phrase" style={{ height: `${getHeight()}px` }}>
      <form className="add-phrase__form" onSubmit={handleSubmit}>
        <input
          className="add-phrase__input"
          onChange={onChange}
          value={name}
          name="name"
          placeholder="Имя"
          autoComplete="off"
          required
        />
        {name.length > 1 && (
          <input
            className="add-phrase__input"
            onChange={onChange}
            value={position}
            name="position"
            placeholder="позиция"
            autoComplete="off"
            required
          />
        )}

        {name.length > 1 && position.length > 1 && (
          <input
            className={`add-phrase__input ${errorStyle}`}
            onChange={onChange}
            value={email}
            name="email"
            placeholder="емайл"
            autoComplete="off"
            required
          />
        )}

        {name.length > 1 && position.length > 1 && isEmail(email) && (
          <input
            className={`add-phrase__input ${errorStyle}`}
            onChange={onChange}
            value={description}
            name="description"
            placeholder="описание мастера"
            autoComplete="off"
            required
          />
        )}
      </form>
    </div>
  );
};

export default AddMaster;
